export default __webpack_public_path__ + "static/media/user-vehicle.7e42d5db.svg";